export default "__VITE_ASSET__dsTOIDu3__"